import React from 'react'
import cls from 'classnames'

import Icon from './Icon'
import Popup from './Popup'

export default function InfoPopup({
  iconName,
  popupClassName,
  popupPosition,
  iconClassName,
  ContentComponent,
  dynamicIcon,
  style,
}) {
  const iconSrc = dynamicIcon || `${STATIC_BASE_URL}/static/webapp/images/info-blue-icon.svg`
  return (
    <Popup
      className={popupClassName}
      style={style}
      position={popupPosition || 'bottomRight'}
      TriggerComponent={
        iconName ? (
          <span style={{ verticalAlign: 'middle', marginLeft: '5px' }}>
            <Icon imageName={iconName} size="16px" />
          </span>
        ) : (
          <img className={cls('is-infoPopup-trigger', iconClassName)} src={iconSrc} />
        )
      }
      ContentComponent={<ContentComponent />}
    />
  )
}
